import React from "react";
import { person } from "../../../components/defaultHeader/assets";
import colors from "../../../utils/colors";
import Button from "../../../components/ui/button";
import Modal from "../../../components/ui/modal";
import { TPatientDetails } from "../../../types";
import { getAge } from "../utils";

interface IProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  patient: TPatientDetails;
}

const PatientDetailsModal = ({ isOpen, onClose, title, patient }: IProps) => {
  return (
    <Modal isOpen={isOpen} onClose={() => onClose(false)} title={title}>
      <div className="mt-6 flex flex-col gap-6 text-sm px-4 sm:px-6 md:px-8">
        {/* Patient name with image */}
        <div className="flex items-center gap-2">
          <img src={person} alt="patient avatar" className="w-8 h-8" />
          <p className="font-medium">{patient["Patient Name"]}</p>
        </div>

        {/* Patient Info Rows */}
        <div className="flex flex-wrap gap-y-4">
          {[
            ["Patient ID", patient["Patient ID"]],
            ["Phone Number", patient["Phone Number"]],
            ["Patient Height(cm)", patient["Patient Height"]],
            ["Patient Weight(Kg)", patient["Patient Weight"]],
            ["Patient Gender", patient["Patient Gender"]],
            ["Patient email", patient["Patient email"]],
            ["Age", getAge(patient["Patient DOB"])],
            ["Patient Blood Group", patient["Patient Blood Group"]],
            ["Patient Blood Genotype", patient["Patient Blood Genotype"]],
          ].map(([label, value], index) => (
            <div key={index} className="w-full sm:w-1/2 md:w-1/3 pr-4">
              <p className="mb-1 text-gray-500">{label}</p>
              <p style={{ color: colors.dark }}>{value}</p>
            </div>
          ))}

          <div className="flex flex-col sm:flex-row sm:flex-wrap">
            {/* Patient Risk Category */}
            <div className="w-full sm:w-1/2 pr-0 sm:pr-4 mb-4 sm:mb-0">
              <p className="mb-1 text-gray-500">Patient Risk Category</p>
              <Button
                text={patient["Category"]}
                theme="primary"
                size="xs"
                className="!rounded-t-[20px] !rounded-b-[20px] w-[100px] !py-2 !p-2"
              />
            </div>

            {/* Date Registered */}
            <div className="w-full sm:w-1/2 pr-0 sm:pr-4 mb-4 sm:mb-0">
              <p className="mb-1 text-gray-500">Date Registered</p>
              <p style={{ color: colors.dark }}>{patient["Date Registered"]}</p>
            </div>

            {/* Patient Notes */}
            <div className="w-full mt-2">
              <p className="mb-1 text-gray-500">Patient Notes</p>
              <p className="break-words" style={{ color: colors.dark }}>
                {patient["Patient Notes"]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PatientDetailsModal;
